
// Navigation items
export const navigationItems = [
  { id: "dashboard", label: "Dashboard", icon: "dashboard", href: "/dashboard" },
  { id: "predictions", label: "Daily Predictions", icon: "today", href: "/matches/daily-predictions" },
  { id: "engine", label: "Titan Engine", icon: "psychology", href: "/titan-engine" },
  { id: "tickets", label: "Tickets", icon: "precision_manufacturing", href: "/tickets" },
  { id: "leaderboard", label: "Leaderboard", icon: "trophy", href: "/leaderboard" },
  { id: "prices", label: "Prices", icon: "credit_card", href: "/prices" },
  { id: "about", label: "About Us", icon: "bubble_chart", href: "/about-us" },
];

// Available leagues for filtering
export const availableLeagues = [
  { id: 'liga1', name: 'Primeira Liga' },
  { id: 'liga2', name: 'Premier League' },
  { id: 'liga3', name: 'Serie A' },
  { id: 'liga4', name: 'Copa del Rey' },
  { id: 'liga5', name: 'Turkey' },
  { id: 'liga6', name: 'Super League' },
  { id: 'liga7', name: 'Champions' }
];

// Mock updates data
export const recentUpdates = [
  {
    id: 1,
    userName: "Mike Tyson",
    message: "Placed a successful bet using the Titan Engine prediction",
    timeAgo: "2 minutes ago",
    avatar: "/images/cristianoronaldo.webp" // Placeholder - will be replaced by your actual image path
  },
  {
    id: 2,
    userName: "Cristiano Ronaldo",
    message: "Won 3000€ with a ticket generated by Titan Prediction",
    timeAgo: "1 hour ago",
    avatar: "/images/cristianoronaldo.webp"
  },
  {
    id: 3,
    userName: "Lionel Messi",
    message: "Subscribed to the premium prediction service",
    timeAgo: "3 hours ago",
    avatar: "/images/cristianoronaldo.webp"
  }
];

// Mock prediction results
export const mockResults = [
  {
    id: 1,
    homeTeam: "FC Barcelona",
    awayTeam: "Real Madrid",
    prediction: "Home Win",
    odds: 1.85,
    confidence: 87,
    league: "La Liga"
  },
  {
    id: 2,
    homeTeam: "Manchester City",
    awayTeam: "Liverpool",
    prediction: "Over 2.5 Goals",
    odds: 1.65,
    confidence: 92,
    league: "Premier League"
  },
  {
    id: 3,
    homeTeam: "Bayern Munich",
    awayTeam: "Borussia Dortmund",
    prediction: "Both Teams to Score",
    odds: 1.70,
    confidence: 89,
    league: "Bundesliga"
  }
];
